import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
	Row,
	Col,
	Card,
	CardBody,
	CardHeader,
	Container,
	Button,
	FormGroup,
	InputGroup,
	InputGroupAddon,
	Input,
	Table,
	Pagination,
	PaginationItem,
	PaginationLink,
} from "reactstrap";
import swal from "sweetalert";
import {
	getProductGroupsList,
	getProducts,
	SetParams,
	productDelete,
	model_open,
	model_close,
} from "../../../store/Masters/Products/actions";
import { makeStyles } from "@material-ui/core/styles";
import TreeView from "@material-ui/lab/TreeView";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TreeItem from "@material-ui/lab/TreeItem";

class Products extends Component {
	constructor(props) {
		super(props);
		this.state = {
			modal_static: false,
			isAlertOpen: false,
			leftSideBarType: "icon",
		};
	}

	componentDidMount() {
		this.props.getProductGroupsList();
		this.props.getProducts({});
	}

	handleDelete(values) {
		this.props.productDelete(values, this.props.history);
	}
	deleteRecord = (record) => {
		swal({
			title: "Are you sure?",
			text: "Once deleted, you will not be able to recover this imaginary file!",
			icon: "warning",
			buttons: true,
			dangerMode: true,
		}).then((willDelete) => {
			if (willDelete) {
				this.handleDelete(record.id);
			} else {
				swal("Your imaginary file is safe!", { timer: 1500 });
			}
		});
	};

	onGroupid(id) {
		this.props.SetParams({ ...this.props.params, group: id, page: 1 });
		this.props.getProducts({ group: id });
	}
	handleSearch = (e) => {
		if (e.key === "Enter") {
			this.props.getProducts({
				...this.props.params,
				page: 1,
				search: e.target.value,
			});
		}
	};
	openPage(pageNo) {
		this.props.SetParams({ ...this.props.params, page: pageNo });
		this.props.getProducts({ ...this.props.params, page: pageNo });
	}

	render() {
		const classes = makeStyles({
			root: {
				height: 110,
				flexGrow: 1,
				maxWidth: 400,
			},
		});
		const renderTree = (nodes) => (
			<TreeItem
				key={nodes.id}
				nodeId={nodes.id}
				label={nodes.name}
				onClick={() => this.onGroupid(nodes.id)}>
				{Array.isArray(nodes.children)
					? nodes.children.map((node) => renderTree(node))
					: null}
			</TreeItem>
		);

		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						<Card>
							<CardHeader className="bg-transparent border-bottom ">
								<Link to="/MastersDashboard">
									<i className="ri-arrow-go-back-fill font-size-18"></i>
								</Link>
								<h4 className="card-title-18 d-inline-block ml-2">
									Product Master
								</h4>
								<div className="float-right">
									<Button
										type="button"
										color="primary"
										className="waves-effect waves-light"
										href="AddProducts/0">
										Add New Product
									</Button>
								</div>
							</CardHeader>
							<CardBody>
								<Row>
									<Col xs={3}>
										<Card>
											<CardHeader className="bg-transparent border-bottom ">
												GROUPS
											</CardHeader>
											<CardBody>
												{this.props.grouplist && (
													<TreeView
														className={classes.root}
														defaultCollapseIcon={
															<ExpandMoreIcon />
														}
														// defaultExpanded={["root"]}
														defaultExpandIcon={
															<ChevronRightIcon />
														}>
														{this.props.grouplist.map(
															(i) => renderTree(i)
														)}
													</TreeView>
												)}
											</CardBody>
										</Card>
									</Col>
									<Col xs={9}>
										<Row>
											<Col md={4}>
												<FormGroup className="m-0">
													<InputGroup>
														<Input
															type="text"
															name="search"
															className="form-control d-inline-block"
															placeholder="Search"
															validate={{
																required: true,
															}}
															onChange={(e) =>
																this.props.SetParams(
																	{
																		...this
																			.props
																			.params,
																		search: e
																			.target
																			.value,
																		page: 1,
																	}
																)
															}
															onKeyDown={(e) =>
																this.handleSearch(
																	e
																)
															}
														/>
														<InputGroupAddon addonType="append">
															<Button
																color="light"
																type="submit"
																onClick={() =>
																	this.props.getProducts(
																		{
																			...this
																				.props
																				.params,
																			page: 1,
																		}
																	)
																}>
																<i className="ri-search-line"></i>
															</Button>
														</InputGroupAddon>
													</InputGroup>
												</FormGroup>
											</Col>
											<Col md={8}>
												<div className="float-right">
													<Pagination aria-label="Page navigation example">
														<PaginationItem
															disabled={
																this.props
																	.params
																	.page <= 1
															}>
															<PaginationLink
																onClick={(e) =>
																	this.openPage(
																		1
																	)
																}
																first
																// href="#"
															/>
														</PaginationItem>

														{this.props.params
															.page > 2 && (
															<PaginationItem
																disabled={
																	this.props
																		.params
																		.page <=
																	2
																}>
																<PaginationLink
																	onClick={() =>
																		this.openPage(
																			this
																				.props
																				.params
																				.page -
																				2
																		)
																	}
																	// href="#"
																>
																	{this.props
																		.params
																		.page -
																		2}
																</PaginationLink>
															</PaginationItem>
														)}
														{this.props.params
															.page > 1 && (
															<PaginationItem
																disabled={
																	this.props
																		.params
																		.page ===
																	1
																}>
																<PaginationLink
																	onClick={() =>
																		this.openPage(
																			this
																				.props
																				.params
																				.page -
																				1
																		)
																	}
																	// href="#"
																>
																	{this.props
																		.params
																		.page -
																		1}
																</PaginationLink>
															</PaginationItem>
														)}

														<PaginationItem
															active={true}>
															<PaginationLink
																onClick={() =>
																	this.openPage(
																		this
																			.props
																			.params
																			.page
																	)
																}
																// href="#"
															>
																{
																	this.props
																		.params
																		.page
																}
															</PaginationLink>
														</PaginationItem>
														{this.props.params
															.page +
															1 <=
															this.props.params
																.no_of_pages && (
															<PaginationItem
																disabled={
																	this.props
																		.params
																		.page +
																		1 >
																	this.props
																		.params
																		.no_of_pages
																}>
																<PaginationLink
																	onClick={() =>
																		this.openPage(
																			this
																				.props
																				.params
																				.page +
																				1
																		)
																	}
																	// href="#"
																>
																	{this.props
																		.params
																		.page +
																		1}
																</PaginationLink>
															</PaginationItem>
														)}
														{this.props.params
															.page +
															2 <=
															this.props.params
																.no_of_pages && (
															<PaginationItem
																disabled={
																	this.props
																		.params
																		.page +
																		2 >
																	this.props
																		.params
																		.no_of_pages
																}>
																<PaginationLink
																	onClick={() =>
																		this.openPage(
																			this
																				.props
																				.params
																				.page +
																				2
																		)
																	}
																	// href="#"
																>
																	{this.props
																		.params
																		.page +
																		2}
																</PaginationLink>
															</PaginationItem>
														)}
														{this.props.params
															.page +
															3 <=
															this.props.params
																.no_of_pages &&
															this.props.params
																.page < 3 && (
																<PaginationItem
																	disabled={
																		this
																			.props
																			.params
																			.page +
																			3 >
																		this
																			.props
																			.params
																			.no_of_pages
																	}>
																	<PaginationLink
																		onClick={() =>
																			this.openPage(
																				this
																					.props
																					.params
																					.page +
																					3
																			)
																		}
																		// href="#"
																	>
																		{this
																			.props
																			.params
																			.page +
																			3}
																	</PaginationLink>
																</PaginationItem>
															)}
														{this.props.params
															.page +
															4 <=
															this.props.params
																.no_of_pages &&
															this.props.params
																.page < 2 && (
																<PaginationItem
																	disabled={
																		this
																			.props
																			.params
																			.page +
																			4 >
																		this
																			.props
																			.params
																			.no_of_pages
																	}>
																	<PaginationLink
																		onClick={() =>
																			this.openPage(
																				this
																					.props
																					.params
																					.page +
																					4
																			)
																		}
																		// href="#"
																	>
																		{this
																			.props
																			.params
																			.page +
																			4}
																	</PaginationLink>
																</PaginationItem>
															)}

														<PaginationItem
															disabled={
																this.props
																	.params
																	.no_of_pages ===
																this.props
																	.params.page
															}>
															<PaginationLink
																onClick={(e) =>
																	this.openPage(
																		this
																			.props
																			.params
																			.no_of_pages
																	)
																}
																last
																// href="#"
															/>
														</PaginationItem>
													</Pagination>
												</div>
											</Col>
										</Row>

										<div
											className="table-responsive m-0"
											style={{
												maxHeight: "550px",
												overflowY: "auto",
											}}>
											<Table
												// striped
												bordered
												hover
												responsive
												className="mb-0 p-0 table-centered">
												<thead className="bg-light text-center">
													<tr>
														<th className="nowrap">
															Code
														</th>
														<th
															style={{
																minWidth:
																	"220px",
															}}>
															Name
														</th>
														<th className="nowrap">
															Brand
														</th>
														<th className="nowrap">
															Sub Group
														</th>
														<th className="nowrap">
															Base Units
														</th>
														<th className="nowrap">
															Department
														</th>
														<th className="nowrap">
															Category
														</th>
														<th className="nowrap">
															Section
														</th>
														<th className="nowrap">
															Action
														</th>
													</tr>
												</thead>
												<tbody>
													{this.props.rowlist.map(
														(product, key) => (
															<tr key={key}>
																<td className="text-center">
																	{
																		product.code
																	}
																</td>
																<td>
																	<h5 className="font-size-14 ">
																		{
																			product.name
																		}
																	</h5>
																</td>
																<td className="text-center">
																	{
																		product.brand_name
																	}
																</td>
																<td className="text-center">
																	{
																		product.subgroup_name
																	}
																</td>
																<td className="text-center">
																	{
																		product
																			.baseunit
																			.name
																	}
																</td>

																<td className="text-center">
																	{
																		product
																			.department
																			?.name
																	}
																</td>
																<td className="text-center">
																	{
																		product
																			.category
																			?.name
																	}
																</td>
																<td className="text-center">
																	{
																		product
																			.section
																			?.name
																	}
																</td>

																<td className="nowrap text-center">
																	<Link
																		to={`AddProducts/${product.id}`}
																		color="primary">
																		<i
																			className="mdi mdi-pencil-box-outline mr-2 font-size-18"
																			title="Edit Product"
																			style={{
																				cursor: "pointer",
																				color: "#fc6f03",
																			}}></i>
																	</Link>
																	<i
																		className="mdi mdi-delete mr-2 font-size-18"
																		title="Delete Product"
																		style={{
																			cursor: "pointer",
																			color: "#ff0000",
																		}}
																		onClick={() =>
																			this.deleteRecord(
																				product
																			)
																		}></i>
																</td>
															</tr>
														)
													)}
												</tbody>
											</Table>
										</div>
									</Col>
								</Row>
							</CardBody>
						</Card>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { rowlist, grouplist, model, message, params } = state.Product;
	return { message, Error, rowlist, grouplist, model, params };
};

export default connect(mapStatetoProps, {
	getProductGroupsList,
	getProducts,
	SetParams,
	productDelete,
	model_open,
	model_close,
})(Products);
